import { Member } from 'src/types/matchControl/member';

/**
 * THE source of truth for line-up member columns and their order. Both the row
 * editor (`MemberRow`) and the spreadsheet paste parser (`parseLineUpPaste`)
 * derive their column order from this list, so the two can never drift apart.
 * Reorder here to reorder everywhere.
 */

export type MemberColumnKey = Exclude<keyof Member, 'id'>;

export type MemberColumn = {
  key: MemberColumnKey;
  label: string;
  numeric: boolean;
  required: boolean;
};

export const MEMBER_COLUMNS = [
  { key: 'number', label: 'Number', numeric: false, required: true },
  { key: 'name', label: 'Name', numeric: false, required: true },
  { key: 'type', label: 'Type', numeric: false, required: true },
  { key: 'goals', label: 'Goals', numeric: true, required: false },
  { key: 'caps', label: 'Caps', numeric: true, required: false },
  { key: 'matches', label: 'Matches', numeric: true, required: false },
  { key: 'age', label: 'Age', numeric: true, required: false },
] as const satisfies readonly MemberColumn[];

export type NumericMemberColumnKey = Extract<
  (typeof MEMBER_COLUMNS)[number],
  { numeric: true }
>['key'];

// Fail the build if a new editable `Member` field is added without listing it here.
// (`satisfies` above already rejects unknown/misshapen columns, and a mislabeled
// `numeric` flag is caught where the value is assigned.)
const assertColumnsCoverMember = <_T extends true>(): void => {};
assertColumnsCoverMember<
  MemberColumnKey extends (typeof MEMBER_COLUMNS)[number]['key'] ? true : false
>();
